import { cn } from '@listening/utils/react-helpers';
import { Button } from '@listening/frontend/components/radix/button';
import { useState } from 'react';
import {
  useAudioChunkPlayer,
  useAudioChunkSelector,
} from '@/lib/audio-chunk-player';
import * as m from '@/paraglide/messages';

export function JumpToCurrentButton({
  showJumpBtn,
  onClick,
}: {
  showJumpBtn: boolean;
  onClick: () => void;
}) {
  return (
    <Button
      className={cn(
        'absolute right-8 bottom-5 z-10 h-6 rounded-full px-3 py-1 transition-all',
        !showJumpBtn && '-bottom-96',
      )}
      data-jump-to-current-btn={showJumpBtn}
      onClick={onClick}
    >
      {m.read_along_jump_to_current()}
    </Button>
  );
}

export function useJumpToCurrentButtonVisibility() {
  const [isCurrentTextVisible, setIsCurrentTextVisible] = useState(true);
  const ttsId = useAudioChunkSelector((s) => s.ttsId);
  const docPackChunk = useAudioChunkSelector((s) => s.docPackChunk);
  const {
    player: { isPlaying },
    isLoadingAudio,
  } = useAudioChunkPlayer();

  return {
    showJumpBtn: Boolean(
      (ttsId || docPackChunk) &&
      isPlaying &&
      !isLoadingAudio &&
      !isCurrentTextVisible,
    ),
    setIsCurrentTextVisible,
  };
}
